import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div<{ size: number }>`
  ${({ theme, size }) => css`
    position: relative;
    width: ${size}px;
    height: ${size}px;
    overflow: hidden;
    overflow: hidden;

    img {
      width: ${size}px;
      height: ${size}px;
      overflow: hidden;
      border: 1px solid ${theme.backgroundColor.bg_light_5_alpha};
      border-radius: 50%;
      object-fit: cover;
    }

    &.multi {
      & > img {
        display: block;
        position: absolute;
        width: calc(${size}px * 0.7);
        height: calc(${size}px * 0.7);
        object-fit: cover;

        &:first-of-type {
          z-index: 1;
          top: 0;
          left: 0;
        }

        &:last-of-type {
          z-index: 2;
          right: 0;
          bottom: 0;
        }
      }
    }

    &.alert {
      &::after {
        content: '';
        display: block;
        position: absolute;
        z-index: 3;
        top: 0;
        left: 0;
        width: 12px;
        height: 12px;
        overflow: hidden;
        border-radius: 50%;
        background: ${theme.themeColor.main_1};
      }
    }
  `}
`;
